/**
 * @generated SignedSource<<80dbd9200e3f43e61625c235dda2f34d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime'
import { FragmentRefs } from 'relay-runtime'
export type StructuredData_cemeteries$data = {
  readonly items: ReadonlyArray<{
    readonly updated_at: string
  }>
  readonly ' $fragmentType': 'StructuredData_cemeteries'
}
export type StructuredData_cemeteries$key = {
  readonly ' $data'?: StructuredData_cemeteries$data
  readonly ' $fragmentSpreads': FragmentRefs<'StructuredData_cemeteries'>
}

const node: ReaderFragment = {
  argumentDefinitions: [],
  kind: 'Fragment',
  metadata: null,
  name: 'StructuredData_cemeteries',
  selections: [
    {
      alias: null,
      args: null,
      concreteType: 'Cemetery',
      kind: 'LinkedField',
      name: 'items',
      plural: true,
      selections: [
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'updated_at',
          storageKey: null
        }
      ],
      storageKey: null
    }
  ],
  type: 'CemeteryResult',
  abstractKey: null
}

;(node as any).hash = '8338ea7cb9ad6a6210b06580fb69ac30'

export default node
